// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__Ve5fJ","scrollbar":"mimic___styles_scrollbar__FI6u4"};